module.exports = __webpack_public_path__ + "img/prizeBtn.5cf71397.png";